import { createSelector } from 'reselect'
import selectTrelloListsById from './selectTrelloListsById'

export default createSelector(selectTrelloListsById, lists => {
  if (!lists) return lists
  return Object.values(lists)
})
